import React from 'react';
import classnames from 'classnames';
import TierPromotionCard from '../../../../DeviationViews/TierPromotionCard';
import EditorDeviationLink from '../../_partials/DeviationLink';
import { getSizeForFreeform } from '../../helpers';
import s from './Tier.scss';
var TierMonoReactView = function (_a) {
    var config = _a.config, settings = _a.settings, deviation = _a.deviation;
    var size = { width: 608, height: 330 };
    // Handle resizing
    size = getSizeForFreeform(size, config.width);
    // This is the size you'd see in left/right aligned setting
    if (config.size === 'small') {
        size = {
            width: 350,
            height: 190,
        };
    }
    // On small editors such as comments
    if (settings && settings.showMediaAlwaysSmall) {
        size = {
            width: 180,
            height: 125,
        };
    }
    return (React.createElement("div", { className: classnames(s['root'], s['normal']), style: { width: size.width } },
        React.createElement(EditorDeviationLink, { link: config.link, deviation: deviation, linkClass: s['tier-link'] },
            React.createElement(TierPromotionCard, { width: size.width, height: size.height, deviation: deviation }))));
};
TierMonoReactView.displayName = 'TierMonoReactView';
export default TierMonoReactView;
//# sourceMappingURL=Tier.js.map